import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface groupManagementInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: groupManagementInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const GroupManagementSlice = createSlice({
  name: 'groupManagementSlice',
  initialState,
  reducers: {
    setGroupManagementMeta: (
      state,
      action: PayloadAction<{
        meta: { total: number | string; limit: number | string };
      }>
    ) => {
      const total = Number(action.payload.meta.total);
      const limit = Number(action.payload.meta.limit);

      state.totalRecords = total;
      state.totalPages = Math.ceil(total / limit);
    }
  }
});
